import type { ReactNode } from "react";
import ProjectActivityDetails from "components/project/project-activity-details/project-activity-details";
import ProjectActivityDoneToggle from "components/project/project-activity-done-toggle";
import ProjectActivityCardMenu from "components/project/project-activity-card-menu";
import { ProjectActivity } from "services/project-activities.service";

type Props = {
  activity: ProjectActivity;
  trailing?: ReactNode;
  busy?: boolean;
  onToggleDone: () => void;
  onEdit: () => void;
  onDelete?: () => void;
  className?: string;
};

export default function ProjectActivityCard({
  activity,
  trailing,
  busy,
  onToggleDone,
  onEdit,
  onDelete,
  className = "",
}: Props) {
  return (
    <div
      className={`flex items-start gap-2.5 rounded-md border border-[var(--p-color-border)] bg-[var(--p-color-bg-surface)] px-3 py-2.5 ${
        activity.isDone ? "opacity-70" : ""
      } ${className}`}
    >
      <ProjectActivityDoneToggle
        done={activity.isDone}
        disabled={busy}
        onToggle={onToggleDone}
      />
      <div className="min-w-0 flex-1">
        <div
          className={`text-sm font-semibold text-[var(--p-color-text)] ${
            activity.isDone ? "line-through" : ""
          }`}
        >
          {activity.title}
        </div>
        <ProjectActivityDetails activity={activity} trailing={trailing} />
      </div>
      <ProjectActivityCardMenu
        disabled={busy}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </div>
  );
}

